// s../store/api/masterApi.ts
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {
  Subject,
  Language,
  School,
  Grade,
  Category,
  GetMasterDataResponse,
} from '../../types/masterTypes';
import { baseQuery } from './baseQuery';

const publicApiUrl = process.env.REACT_APP_PUBLIC_API_URL;

// Create the master API slice
export const masterApi = createApi({
  reducerPath: 'masterApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${publicApiUrl}/master`,
  }),
  endpoints: builder => ({
    getSubjects: builder.query<Subject[], void>({
      query: () => ({
        url: '/subjects',
        method: 'GET',
        headers: {
          accept: '*/*',
        },
      }),
      transformResponse: (response: GetMasterDataResponse<Subject>) =>
        response.data.arrayObj,
    }),
    getLanguages: builder.query<Language[], void>({
      query: () => ({
        url: '/language',
        method: 'GET',
        headers: {
          accept: '*/*',
        },
      }),
      transformResponse: (response: GetMasterDataResponse<Language>) =>
        response.data.arrayObj,
    }),
    getSchools: builder.query<School[], void>({
      query: () => ({
        url: '/schools',
        method: 'GET',
        headers: {
          accept: '*/*',
        },
      }),
      transformResponse: (response: GetMasterDataResponse<School>) =>
        response.data.arrayObj,
    }),
    getGrades: builder.query<Grade[], void>({
      query: () => ({
        url: '/grades',
        method: 'GET',
        headers: {
          accept: '*/*',
        },
      }),
      transformResponse: (response: GetMasterDataResponse<Grade>) =>
        response.data.arrayObj,
    }),
    getCategories: builder.query<Category[], void>({
      query: () => ({
        url: '/category',
        method: 'GET',
        headers: {
          accept: '*/*',
        },
      }),
      transformResponse: (response: GetMasterDataResponse<Category>) =>
        response.data.arrayObj,
    }),
  }),
});

export const {
  useGetSubjectsQuery,
  useGetLanguagesQuery,
  useGetSchoolsQuery,
  useGetGradesQuery,
  useGetCategoriesQuery,
} = masterApi;
